import { AxiosHttpClient } from "@/shared/infra/http";
export var makeAxiosHttpClient = function () { return new AxiosHttpClient(); };
